interface NavigationProps {
  scrolled: boolean;
}

export default function Navigation({ scrolled }: NavigationProps) {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-white shadow-md' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
        <div className="hidden md:flex items-center space-x-8">
          <button
            onClick={() => scrollToSection('home')}
            className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
              scrolled ? 'text-gray-800 hover:text-amber-600' : 'text-white hover:text-amber-300'
            }`}
          >
            ホーム
          </button>
          <button
            onClick={() => scrollToSection('about')}
            className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
              scrolled ? 'text-gray-800 hover:text-amber-600' : 'text-white hover:text-amber-300'
            }`}
          >
            Spring Sun Bowlについて
          </button>
          <button
            onClick={() => scrollToSection('features')}
            className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
              scrolled ? 'text-gray-800 hover:text-amber-600' : 'text-white hover:text-amber-300'
            }`}
          >
            特徴
          </button>
          <button
            onClick={() => scrollToSection('lineup')}
            className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
              scrolled ? 'text-gray-800 hover:text-amber-600' : 'text-white hover:text-amber-300'
            }`}
          >
            ラインナップ
          </button>
          <button
            onClick={() => scrollToSection('how-to-use')}
            className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
              scrolled ? 'text-gray-800 hover:text-amber-600' : 'text-white hover:text-amber-300'
            }`}
          >
            使用方法
          </button>
          <button
            onClick={() => scrollToSection('kiln')}
            className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
              scrolled ? 'text-gray-800 hover:text-amber-600' : 'text-white hover:text-amber-300'
            }`}
          >
            窯元紹介
          </button>
          <button
            onClick={() => scrollToSection('venues')}
            className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
              scrolled ? 'text-gray-800 hover:text-amber-600' : 'text-white hover:text-amber-300'
            }`}
          >
            吸える場所
          </button>
          <button
            onClick={() => scrollToSection('contact')}
            className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
              scrolled ? 'text-gray-800 hover:text-amber-600' : 'text-white hover:text-amber-300'
            }`}
          >
            SNS
          </button>
          <button
            onClick={() => scrollToSection('location')}
            className={`px-6 py-2 rounded-full border-2 transition-all whitespace-nowrap cursor-pointer ${
              scrolled
                ? 'border-amber-600 text-amber-600 hover:bg-amber-600 hover:text-white'
                : 'border-amber-300 text-amber-300 hover:bg-amber-300 hover:text-gray-900'
            }`}
          >
            アクセス
          </button>
        </div>
      </div>
    </nav>
  );
}